const SECTIONS = [
  ["Information we collect", [
    "Business contact information (name, role, email, phone)",
    "Business identifiers (legal name, ABN/ACN, industry)",
    "Site information (address, ownership, roof and switchboard details)",
    "Electricity usage information (bills, NMI, load profiles, interval data)",
    "Uploaded documents (bills, photos, CSV/XLSX files)",
    "Communications between you and Be Green Group",
  ]],
  ["How we use this information", [
    "To assess whether your business may be suitable for a commercial PPA",
    "To design and prepare an indicative proposal",
    "To contact you about your application and any subsequent PPA",
    "To improve our services and product offering",
    "To comply with legal, regulatory and contractual obligations",
  ]],
  ["Contact and marketing consent", [
    "We only contact applicants who have submitted the application form or opted in via other channels.",
    "You can request to stop receiving marketing communications at any time by emailing us.",
  ]],
  ["Data security", [
    "We use reasonable technical and organisational measures to protect the information we hold.",
    "Access to your information is limited to Be Green Group staff and authorised partners assisting with your application or PPA.",
  ]],
  ["Access, correction and deletion", [
    "You may request access to the personal information we hold about you.",
    "You may request correction of inaccurate information.",
    "You may request deletion of your information, subject to legal, contractual and record-keeping obligations.",
  ]],
];

export default function PrivacyPolicy() {
  return <LegalPage title="Privacy Policy" sections={SECTIONS} testId="privacy-policy" placeholderNote />;
}

export function LegalPage({ title, intro, sections, testId, placeholderNote }) {
  return (
    <div>
      <section className="container-x mx-auto max-w-4xl pt-14 md:pt-24 pb-16" data-testid={testId}>
        <p className="text-forest text-xs tracking-[0.18em] uppercase font-semibold mb-4">Legal</p>
        <h1 className="font-heading text-4xl md:text-6xl font-semibold text-forest leading-[1.03] tracking-tight">{title}</h1>
        {intro && <p className="mt-5 text-neutral-600 text-lg leading-relaxed">{intro}</p>}
        {placeholderNote && (
          <div className="mt-6 rounded-2xl bg-mist p-5 border border-black/5">
            <p className="text-[13px] text-neutral-600 leading-relaxed">
              <span className="font-semibold text-forest">Placeholder text.</span> This document is
              placeholder content prepared for review by legal counsel. It does not constitute
              legal advice. Be Green Group will replace this content with a finalised policy prior
              to launch.
            </p>
          </div>
        )}

        <div className="mt-10 grid gap-8">
          {sections.map(([h, items]) => (
            <section key={h}>
              <h2 className="font-heading text-2xl font-semibold text-forest">{h}</h2>
              <ul className="mt-4 space-y-2.5 list-disc pl-5 text-[15px] text-neutral-700 leading-relaxed">
                {items.map((it) => <li key={it}>{it}</li>)}
              </ul>
            </section>
          ))}
        </div>
      </section>
    </div>
  );
}
